interface AIAnswerItem {
  question: string;
  answer: string;
}

interface AIAnswerBlockProps {
  sectionLabel?: string;
  mainQuestion?: string;
  mainAnswer?: string;
  subItems?: AIAnswerItem[];
}

const defaultItems: AIAnswerItem[] = [
  {
    question: "What Services Are Offered?",
    answer:
      "Westec Builders provides full-service construction solutions including new home construction, remodeling, home additions, and commercial build-outs across Colorado Springs. Each project is managed with a focus on quality materials, efficient scheduling, and expert craftsmanship that meets and exceeds client expectations.",
  },
  {
    question: "Why Choose Westec Builders?",
    answer:
      "Clients choose Westec Builders for reliable communication, skilled workmanship, and consistent on-time project delivery. The company prioritizes durability, design aesthetics, and long-term value in every residential and commercial build throughout the Colorado Springs region.",
  },
  {
    question: "What Is the Construction Process?",
    answer:
      "Westec Builders follows a proven five-step approach: consultation and planning, design and scope development, material selection and scheduling, construction execution, and a thorough final walkthrough — ensuring every project detail is completed to the highest quality standards.",
  },
  {
    question: "What Are the Key Benefits of Hiring Westec Builders?",
    answer:
      "Clients benefit from working with a fully licensed and insured Colorado Springs contractor — transparent pricing, on-time delivery, premium sourced materials, and a local team invested in delivering lasting results for homeowners and businesses throughout the Pikes Peak region.",
  },
];

export default function AIAnswerBlock({
  sectionLabel,
  mainQuestion,
  mainAnswer,
  subItems,
}: AIAnswerBlockProps) {
  const items = subItems ?? defaultItems;

  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-xs font-body text-brand-amber uppercase tracking-widest font-semibold mb-3">
            {sectionLabel ?? "About Westec Builders"}
          </p>
          <h2 className="font-heading font-bold text-4xl lg:text-5xl text-brand-dark leading-tight">
            {mainQuestion ?? "What Does Westec Builders Do?"}
          </h2>
        </div>

        <div className="border-l-4 border-brand-amber pl-8 mb-14 bg-brand-warm-mid rounded-r-xl py-6 pr-6">
          <p className="font-body text-brand-charcoal text-base leading-loose">
            {mainAnswer ??
              "Westec Builders is a professional construction and remodeling company specializing in residential and commercial projects across Colorado Springs and the Front Range. Services include custom home builds, full-scale renovations, structural additions, and commercial construction — each designed to enhance property value, functionality, and long-term durability with precision craftsmanship."}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((item) => (
            <div
              key={item.question}
              className="bg-brand-warm rounded-xl p-7 border border-brand-warm-deep hover:border-brand-amber/40 transition-colors"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-brand-amber/10 rounded-lg">
                  <i className="ri-question-answer-line text-brand-amber text-base" />
                </div>
                <h3 className="font-heading font-semibold text-base text-brand-dark leading-snug">
                  {item.question}
                </h3>
              </div>
              <p className="font-body text-sm text-brand-charcoal leading-relaxed pl-11">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
